import { SystemOptionType } from 'data/types';
import { DuctedComponentSwapHandler } from 'hooks/use-ducted-component-swap';
import useDuctedSwapCandidates from 'hooks/use-ducted-swap-candidates';
import { DuctedSwapLockState } from 'utils/ducted-component-swap-types';
import DuctedCondenserComponentGroup from './ducted-condenser-component-group';

type DuctedSystemComponentsTableProps = Readonly<{
  option: SystemOptionType;
  onComponentSwap?: DuctedComponentSwapHandler;
  lockState?: DuctedSwapLockState;
}>;

export default function DuctedSystemComponentsTable({
  option,
  onComponentSwap,
  lockState
}: DuctedSystemComponentsTableProps) {
  const { candidates, isLoading } = useDuctedSwapCandidates(option);

  return (
    <div className='flex flex-col gap-4'>
      {option.configuration.condensers.map((condenser) => (
        <DuctedCondenserComponentGroup
          key={condenser.uniqueId}
          condenser={condenser}
          candidates={candidates}
          isLoading={isLoading}
          onComponentSwap={onComponentSwap}
          lockState={lockState}
        />
      ))}
    </div>
  );
}
